<template>
  <div class="px-2 space-y-1 py-1 !select-none">
    <slot />
  </div>
</template>
